import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const GenderWiseItemQuantity = () => {

  const token = localStorage.getItem("token");

  const [genderList, setGenderList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [items, setItems] = useState([]);

  const [filters, setFilters] = useState({
    gender_id: "",
    class_id: "",
    item_id: ""
  });

  const [rows, setRows] = useState([]);

  // ================= GENDER LIST =================

  const fetchGenderList = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/genderList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setGenderList(res.data.data.genderList || []);
    } catch (error) {
      console.log(error);
    }
  };

  // ================= CLASS LIST =================

  const fetchClassList = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setClassList(res.data.data.class_list || []);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchItemsList = async() => {
      try{
  const token = localStorage.getItem("token");

      const res = await axios.post(`${BASE_URL}/itemsList`,{},
       {

        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  const filteredItems =
        res.data?.data?.itemsList?.filter(
          (item) => Number(item.status) !== 0
        ) || [];

      setItems(filteredItems);
      }catch(err){
          console.log(err);
      }
   }

  // ================= TABLE LIST API =================

  const fetchTableData = async (customFilters = filters) => {
  try {

    const res = await axios.post(
      `${BASE_URL}/classGenderWiseItemQuantity`,
      {
        gender_id: customFilters.gender_id || "",
        class_id: customFilters.class_id || "",
        item_id: customFilters.item_id || ""
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setRows(res.data.data || []);

  } catch (error) {
    console.log(error);
  }
};

  // ================= LOAD DATA =================

  useEffect(() => {
    fetchGenderList();
    fetchClassList();
    fetchTableData();
    fetchItemsList();
  }, []);

  // ================= SEARCH =================

  const handleSearch = () => {
    fetchTableData(filters);
  };

  // ================= RESET =================

  const handleReset = () => {

    const resetFilters = {
      gender_id: "",
      class_id: "",
      item_id: ""
    };

    setFilters(resetFilters);

    fetchTableData(resetFilters);

  };

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    textAlign: "center",
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1500 }}>

      {/* ================= FILTER CARD ================= */}

      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg,#E3F2FD,#ffffff)",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)"
        }}
      >

        <div
          className="px-4 py-3 text-white"
          style={{
            background: "linear-gradient(90deg,#0D47A1,#1565C1)"
          }}
        >
          <h5 className="mb-0">Gender Wise Item & Quantity</h5>
        </div>

        <Card.Body>

          <Row>

            {/* Gender */}

            <Col md={3}>
              <Form.Group>
                <Form.Label className="fw-semibold">Gender</Form.Label>

                <Form.Select
                  value={filters.gender_id}
                  onChange={(e) =>
                    setFilters({ ...filters, gender_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">All Gender</option>

                  {genderList.map((gender) => (
                    <option key={gender.id} value={gender.id}>
                      {gender.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Class */}

            <Col md={3}>
              <Form.Group>
                <Form.Label className="fw-semibold">Class</Form.Label>

                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">All Class</option>

                  {classList.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Record Showing */}

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Items</Form.Label>
                <Form.Select
                  value={filters.item_id}
                  onChange={(e) =>
                    setFilters({ ...filters, item_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Selct Item</option>
                  {items.map((g) => (
                    <option key={g.id} value={g.id}>
                      {g.item_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Buttons */}

            <Col md={4} className="d-flex gap-3 mt-3">
                                         {/* SEARCH */}
                                         <Button
                                           className="w-50 fw-semibold text-white"
                                           style={{
                                             background: "#1565C1",
                                             border: "none",
                                             borderRadius: "10px",
                                             transition: "0.3s",
                                           }}
                                           onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                           onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                                           onClick={handleSearch}
                                         >
                                           <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                                         </Button>

                                         {/* RESET */}
                                         <Button
              className="w-50 fw-semibold text-white"
              style={{
                background: "#E53935",
                border: "none",
                borderRadius: "10px",
                transition: "0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
              onMouseLeave={(e) => (e.target.style.background = "#E53935")}
              onClick={handleReset}
            >
              <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
            </Button>

                                       </Col>

          </Row>

        </Card.Body>

      </Card>


      {/* ================= TABLE ================= */}

      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >

        <Card.Body>

          <Table bordered hover responsive striped>

            <thead>
              <tr>
                <th style={theadStyle}>SL</th>
                <th style={theadStyle}>Gender</th>
                <th style={theadStyle}>Class</th>
                <th style={theadStyle}>Item</th>
                <th style={theadStyle}>Quantity</th>
              </tr>
            </thead>

            <tbody>

              {rows.length > 0 ? (

                rows.map((row, index) => (

                  <tr key={index}>

                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{row.gender_name}</td>
                    <td className="text-center">{row.class_names}</td>
                    <td className="text-center">{row.item_name}</td>
                    <td className="text-center">{row.default_quantity}</td>

                  </tr>

                ))

              ) : (

                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No Data Found
                  </td>
                </tr>

              )}

            </tbody>

          </Table>

        </Card.Body>

      </Card>

    </div>
  );
};

export default GenderWiseItemQuantity;
